import React, { useState } from 'react'
import axios from 'axios'
import config from '../config'
import sheetsIcon from '../assets/sheetsicon.png'
import '../styles/FeedbackDownloadExcel.css'

const ExcelDownloadButton = ({ urlSuffix, defaultFilename = 'download.xlsx' }) => {
  const [loading, setLoading] = useState(false)
  const handleDownload = async () => {
    setLoading(true)
    const token = localStorage.getItem('token')
    try {
      const response = await axios.get(`${config.apiUrl}/historico${urlSuffix}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      const nomeArquivo =
        response.headers['content-disposition']
          ?.split('filename=')[1]
          ?.replace(/"/g, '') || defaultFilename
      link.setAttribute('download', nomeArquivo)
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (err) {
      console.error('Erro ao fazer download do Excel:', err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="feedback-download-container">
      <button onClick={handleDownload} disabled={loading}>
        <img src={sheetsIcon} alt="Download Excel" className="sheets-icon" />
        {loading ? 'Baixando...' : 'Download Excel'}
      </button>
    </div>
  )
}

export default ExcelDownloadButton
